/**
 * Welche Kampagnen gehören dem Assistenten „Neue Kampagne“?
 *
 * Nur Kampagnen mit gespeichertem `wizard`-Stand. Alte, von Hand gebaute Recruiting-Entwürfe bleiben im
 * alten Builder: der Assistent würde ihren Ablauf ab Schritt 5 still durch einen eigenen ersetzen.
 * Geklont wird eine Wizard-Kampagne ebenfalls im Assistenten (eigene Blacklists, Bewertung der Kontakte).
 */

export interface WizardAware {
  wizard?: unknown;
}

export const isWizardCampaign = (funnel: WizardAware | null | undefined): boolean =>
  !!funnel && !!funnel.wizard && typeof funnel.wizard === 'object';

/** Entwurf einer Recruiting-Wizard-Kampagne: „Bearbeiten“ öffnet den Assistenten. */
export const editsInWizard = (isRecruiting: boolean, isDraft: boolean, funnel: WizardAware | null | undefined): boolean =>
  isRecruiting && isDraft && isWizardCampaign(funnel);

/** „Kopieren“ einer Recruiting-Wizard-Kampagne läuft über den Klonpfad des Assistenten. */
export const clonesInWizard = (isRecruiting: boolean, funnel: WizardAware | null | undefined): boolean =>
  isRecruiting && isWizardCampaign(funnel);
